import  {GET_UNIQUE_VALUES} from "../constants/actionTypes";
import * as api from "../api/index.js";

export const getUniqueValues = (formData) => async (dispatch) => {
  try {
    const response = await api.getUniqueValues(formData);
    dispatch({
      type: GET_UNIQUE_VALUES,
      payload: response.data, // ✅ fix here
    });
    return response.data.unique_values; // ✅ directly return array to use in component
  } catch (error) {
    console.error("GET_UNIQUE_VALUES error", error);
    throw error;
  }
};

